import React from 'react';
import { Dialog, Slide, Theme, makeStyles, createStyles, Button, List, ListItem } from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions/transition';
import ModalHeader from '../../common/ModalHeader';
import { useTranslation } from 'react-i18next';
import PublicServiceAboutBody from './PublicServiceAboutBody';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      position: 'relative',
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {
      boxShadow: '0 2px 2px 0 rgba(0,0,0,0.30)',
      borderRadius: '2px',
    }
  }),
);

const Transition = React.forwardRef<unknown, TransitionProps>(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PublicServiceAboutDialog: React.FC = () => {
  const classes = useStyles();
  const [openDialog, setOpenDialog] = React.useState(false);
  const { t  } = useTranslation();
  // ダイアログを閉じる場合
  const handleClose = () => {
    setOpenDialog(false);
  };
  const handleOpen = () => {
    setOpenDialog(true);
  }
  return (
    <div>
      <div onClick={handleOpen}>
        {t('about_service')}
      </div>
      <Dialog fullScreen open={openDialog} onClose={handleClose} TransitionComponent={Transition} scroll='body'>
        <ModalHeader
          handleClose={handleClose}
          title={t('about_service')}
        />
        <List>
          <ListItem>
              <PublicServiceAboutBody/>
          </ListItem>
          <ListItem>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={handleClose}
            >
              {t('close')}
            </Button>
          </ListItem>
        </List>
      </Dialog>
    </div>
  )
}

export default PublicServiceAboutDialog;
